import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '../../theme/ThemeComponent';
import { TabHeader } from '../../components/TabHeader/TabHeader';
import { log } from 'console';

@Component
export class ProductHotspot extends ThemeComponent {

    @Ref tabHeader!: TabHeader;
    @Ref productTabContent !: HTMLDivElement[];

    init() {
        this.$subscribe(this.tabHeader.onTabChange, this.productTabChanged.bind(this));
    }
    private productTabChanged(tab: string) {
        const prevActiveButton = this.tabHeader.querySelector('.tab-header__button--active');
        if (prevActiveButton?.getAttribute('value') !== tab) {
            prevActiveButton?.classList.remove('tab-header__button--active');
            this.tabHeader.querySelector(`[value="${tab}"]`)?.classList.add('tab-header__button--active');
        }
        const prevActiveContent = this.querySelector('.product-tab-content--active');
        if (prevActiveContent?.getAttribute('name') !== tab) {
            const allPrevActiveContent = this.querySelectorAll('.product-tab-content--active');

            for (const content of allPrevActiveContent) {
                content?.classList.remove('product-tab-content--active');
            }

            for (const content of this.productTabContent) {
                if (content.getAttribute('name') === tab) {
                    content.classList.add('product-tab-content--active');
                }
            }
        }
    }
}
